import React, { ChangeEvent, useCallback } from 'react';

import { Checkbox, GridLegacy as Grid, InputLabel } from '@mui/material';

import { REGION_REPLICATION_MAP } from '~/consts/regionReplication';

interface RegionToggleProps {
  initialEnabledRegion: string;
  enabledRegions: Array<string>;
  onRegionsChange: (regions: Array<string>) => void;
}

function RegionToggle({ initialEnabledRegion, enabledRegions, onRegionsChange }: RegionToggleProps) {
  const handleToggle = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const region = e.target.id.replace('checkbox_', '');
      const newEnabledRegions = enabledRegions.includes(region)
        ? enabledRegions.filter((r) => r !== region)
        : [...enabledRegions, region];

      onRegionsChange(newEnabledRegions);
    },
    [enabledRegions, onRegionsChange],
  );

  const replicationRegions = REGION_REPLICATION_MAP[initialEnabledRegion];
  if (!replicationRegions) {
    return null;
  }

  return (
    <>
      {replicationRegions.map((region) => (
        <Grid key={region} item>
          <Grid container gap={1} alignItems="center">
            <InputLabel htmlFor={'checkbox_' + region}>{region}</InputLabel>
            <Checkbox id={'checkbox_' + region} checked={enabledRegions.includes(region)} onChange={handleToggle} />
          </Grid>
        </Grid>
      ))}
    </>
  );
}

export default RegionToggle;
